import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { mountVersionGuard } from '@version-guard';
import App from './App';
import './index.css';

// Ver comentario en admin-portal/src/main.tsx.
// Politica 'auto-when-idle': el login es una visita corta, sin trabajo que
// perder mas alla del formulario en curso — que igual protegemos. Preferimos
// que un usuario nuevo nunca vea una version vieja del flujo de alta.
mountVersionGuard({
  portal: 'login-portal',
  appName: 'el portal',
  policy: 'auto-when-idle',
  // Las URLs de acá llevan estado de un solo uso: el `code` de OAuth, el
  // token de verificacion de mail, el `pt` de retorno de pago. Con query o
  // hash presentes no recargamos solos — mostramos el banner y decide el
  // usuario. Vale mas no romperle el alta a alguien que ganar una recarga.
  urlStateIsFragile: true,
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('root element missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
